import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/App"; // Corrigido para refletir a nova localização
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
